var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-card"},[_c('h3',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.data.content)+" "),(_vm.data.change)?_c('span',{staticClass:"change"},[_vm._v("("+_vm._s(_vm.data.change)+")")]):_vm._e()]),_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.data.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }